<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.select1 .el-input__inner {width: 150px;}
.ziduanKey .el-input__inner {width: 340px;}
.level .el-input__inner {width: 150px;}
.sort .el-input__inner {width: 150px;}
.date-picker.el-input {width: 200px;}
.count .el-input__inner {width: 50px;}
.el-checkbox {margin-right: 0px;}
.el-checkbox__inner {border-radius: 50%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .btn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.select1 /deep/ .el-input__inner {width: 150px;}
.ziduanKey /deep/ .el-input__inner {width: 340px;}
.level /deep/ .el-input__inner {width: 150px;}
.sort /deep/ .el-input__inner {width: 150px;}
.count /deep/ .el-input__inner {width: 50px;}
.pagination{margin-bottom: 40px;}
.btn {margin: 0px auto;height: 60px;z-index: 19999;}
.btn .el-button {height: 40px;margin: 10px auto;}
.btn {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center',}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="userid" label="用户id"></el-table-column>
          <el-table-column prop="opertype" label="操作类型"></el-table-column>
          <el-table-column prop="opertime" label="操作时间"></el-table-column>
          <el-table-column prop="sign_state" label="完整性校验"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import filters from '../method/filter'
import method from '../method/methods'
import {mapState} from 'vuex'
export default {
  mixins: [filters, method],
  data()
  {
    return {
      form: {
        count: 15
      },
      pageSize: 15,
      currentPage: 1,
      countSum: null,
      //分类数据
      classifydata: [],
      //列表数据
      tableData: [],
      allUserList: []
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID,
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    },
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '1')
          this.getUserName()
        this.$store.commit('onIsLb', '0')
      },
      deep: true,
      immediate: true
    }
  },
  filters:
  {
    gender: function(num)
    {
      switch (num)
      {
      case 0: return '男'
      case 1: return '女'
      }
    }
  },
  created()
  {
    this.getUserName()
  },
  methods: {
    //获取数据
    getList()
    {
      let count = this.form.count
      let currentPage = this.currentPage
      let exp = ''
      exp = 'id > 0'
      let paras = {cmd: 'query', _major: 99, _minor: 39, _exp: exp, init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.countSum = ret[0].total
        const userMap = this.allUserList.reduce((map, user) =>
        {
          map[user.id] = user.name
          return map
        }, {})
        console.log(userMap)
        console.log(ret[0].data)
        this.tableData = []
        ret[0].data.forEach((item) =>
        {
          const userName = userMap[item.userid] || '未知用户'
          this.tableData.push({
            id: item.id,
            opertype: item.opertype,
            userid: userName,
            opertime: item.opertime,
            sign_state: item.sign_state
          })
        })
      })
    },
    getUserName()
    {
      let paras1 = {cmd: 'query', _major: 99, _minor: 13, _exp: 'id>0'}
      window.post.getPost(paras1).then((ret) =>
      {
        this.allUserList = []
        ret.forEach((item) =>
        {
          this.allUserList.push({...item})
        })
        if (this.allUserList.length > 0)
        
          this.getList()
      })
    },
    //点击修改
    updatafn(row)
    {
      this.$router.push({path: '/RoleUpdate', query: {id: row.id}})
    },
    look()
    {
    },
    tree(row)
    {
      this.$emit('addTab2')
      this.$store.commit('treeSubmit', row.id)
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    //子组件调用新增添加Tabs
    addfn()
    {
      this.$emit('addTab')
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      let str = 'count'
      let that = this
      window.public.cancelfnBtn(str, that)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/OperLogLB.vue